import React, { useState } from 'react';
import { Card, Table, DatePicker, Tag, Space, Button } from 'antd';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import useAuthStore from '../../store/useAuthStore';
import { getConsumptionReport } from '../../api/reports.api';
import { formatQty, exportToCSV } from '../../utils/formatters';

const ConsumptionReportPage = () => {
  const { user } = useAuthStore();
  const [dates, setDates] = useState([dayjs().startOf('month'), dayjs()]);

  const { data, isLoading } = useQuery({
    queryKey: ['consumptionReport', user.plantID, dates],
    queryFn: () => getConsumptionReport(user.plantID, { from: dates[0].format('YYYY-MM-DD'), to: dates[1].format('YYYY-MM-DD') }),
    enabled: !!user.plantID
  });

  const columns = [
    { title: 'Date', dataIndex: 'productionDate' },
    { title: 'Raw Material', dataIndex: 'rawName' },
    { title: 'Expected Qty', dataIndex: 'expectedQty', render: v => formatQty(v) },
    { title: 'Actual Qty', dataIndex: 'consumptionQty', render: v => formatQty(v) },
    { title: 'Wastage', dataIndex: 'wastageQty', render: v => formatQty(v) },
    { 
      title: 'Wastage %', 
      render: (_, r) => {
        const pct = r.consumptionQty > 0 ? (r.wastageQty / r.consumptionQty) * 100 : 0;
        const color = pct > 5 ? 'red' : pct > 2 ? 'orange' : 'green';
        return <Tag color={color}>{pct.toFixed(2)}%</Tag>
      }
    }
  ];

  return (
    <Card title="Consumption & Wastage Analysis">
      <Space className="no-print" style={{ marginBottom: 16 }}>
        <DatePicker.RangePicker value={dates} onChange={setDates} />
        <Button onClick={() => window.print()}>Print</Button>
        <Button onClick={() => exportToCSV(data || [], columns, 'ConsumptionReport')}>CSV</Button>
      </Space>
      <Table dataSource={data || []} columns={columns} loading={isLoading} />
    </Card>
  );
};

export default ConsumptionReportPage;